import ko from "knockout";
import { compact, every, filter, flatMap, flow, get, pick } from "lodash/fp";
import { Models } from "purecloud-platform-client-v2";
import authService from "../services/authService";

const requiredCustomerJourneySessionProps = [
    "mediaType",
    "journeyCustomerId",
    "journeyCustomerIdType",
    "journeyCustomerSessionId",
    "journeyCustomerSessionIdType",
] as const;

type RequiredCustomerJourneySessionProp = Required<
    Pick<
        Models.AnalyticsSession,
        (typeof requiredCustomerJourneySessionProps)[number]
    >
>;

type CustomerJourneySession = RequiredCustomerJourneySessionProp &
    Models.AnalyticsSession;

export type CustomerJourneyContext = Required<
    Pick<Models.AnalyticsParticipant, "participantName"> &
        RequiredCustomerJourneySessionProp
>;

const EXTERNAL_CONTACTS_SESSION_VIEW_PERMISSION =
    "perm:externalContacts:session:view";

export const pickContextData: (
    conversation: Models.AnalyticsConversation
) => CustomerJourneyContext[] = flow(
    get("participants"),
    filter("purpose"),
    flatMap(({ externalContactId }: Models.AnalyticsParticipant) =>
        externalContactId ? [{ externalContactId }] : []
    ),
    compact
);

export const hasPermissionsToViewJourneyGadget = (): boolean => {
    const shouldIgnoreDivisions = true;

    return authService.hasAuthorization(
        { all: [EXTERNAL_CONTACTS_SESSION_VIEW_PERMISSION] },
        shouldIgnoreDivisions
    );
};
